// Типы для корректировочных счетов-фактур

export enum CorrectionType {
  CORRECTION = 'CORRECTION',
  CANCELLATION = 'CANCELLATION',
  REPLACEMENT = 'REPLACEMENT'
}

export enum CorrectionInvoiceStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}

export interface CorrectionInvoiceItem {
  id?: string;
  originalItemId: string;
  description: string;
  unitOfMeasure?: string;
  
  // Оригинальные значения
  originalQuantity: number;
  originalUnitPrice: number;
  originalTotalPrice: number;
  originalTaxRate: number;
  originalTaxAmount: number;
  
  // Скорректированные значения
  correctedQuantity: number;
  correctedUnitPrice: number;
  correctedTotalPrice: number;
  correctedTaxRate: number;
  correctedTaxAmount: number;
  
  // Разности
  quantityDifference: number;
  priceDifference: number;
  totalDifference: number;
  taxDifference: number;
  
  sortOrder: number;
}

export interface CorrectionInvoice {
  id?: string;
  originalInvoiceId: string;
  originalInvoiceNumber: string;
  correctionNumber: string;
  correctionDate: string;
  reason: string;
  correctionType: CorrectionType;
  status: CorrectionInvoiceStatus;
  companyId: string;
  companyName: string;
  createdById: string;
  createdByName: string;
  
  // Клиент оригинального счета
  clientName: string;
  
  // Суммы
  originalTotalAmount: number;
  correctedTotalAmount: number;
  differenceAmount: number;
  originalVatAmount: number;
  correctedVatAmount: number;
  differenceVatAmount: number;
  
  // Валютные поля
  currency: string;
  exchangeRate: number;
  
  // Язык PDF
  pdfLanguage?: string;
  
  // Метаданные
  createdAt?: string;
  updatedAt?: string;
  
  // Позиции
  items: CorrectionInvoiceItem[];
}

export interface CreateCorrectionInvoiceRequest {
  originalInvoiceId: string;
  correctionNumber: string;
  correctionDate: string;
  reason: string;
  correctionType: CorrectionType;
  currency?: string;
  bankAccountId?: string;
  exchangeRate?: number;
  pdfLanguage?: string;
  items: CreateCorrectionInvoiceItemRequest[];
}

export interface CreateCorrectionInvoiceItemRequest {
  originalItemId: string;
  description: string;
  unitOfMeasure?: string;
  originalQuantity: number;
  originalUnitPrice: number;
  originalTotalPrice: number;
  originalTaxRate: number;
  originalTaxAmount: number;
  correctedQuantity: number;
  correctedUnitPrice: number;
  correctedTotalPrice: number;
  correctedTaxRate: number;
  correctedTaxAmount: number;
  sortOrder: number;
}

export interface CorrectionInvoiceFormData {
  originalInvoiceId: string;
  correctionNumber: string;
  correctionDate: string;
  reason: string;
  correctionType: CorrectionType;
  currency?: string;
  bankAccountId?: string;
  exchangeRate?: number;
  pdfLanguage?: string;
  items: CorrectionInvoiceItemFormData[];
}

export interface CorrectionInvoiceItemFormData {
  originalItemId: string;
  description: string;
  unitOfMeasure?: string;
  originalQuantity: number;
  originalUnitPrice: number;
  originalTotalPrice: number;
  originalTaxRate: number;
  originalTaxAmount: number;
  correctedQuantity: number;
  correctedUnitPrice: number;
  correctedTotalPrice: number;
  correctedTaxRate: number;
  correctedTaxAmount: number;
  sortOrder: number;
}

